import React from 'react';
import { Alert, AlertDescription } from '../ui/alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

/**
 * AmbassadorReferralBanner
 * 
 * Banner que se muestra cuando un usuario llega a través de un link de referido
 * Muestra información del embajador que compartió el link
 * 
 * @param {string} ambassadorName - Nombre del embajador
 * @param {string} ambassadorAlias - Alias del embajador (opcional)
 * @param {function} onDismiss - Callback cuando el usuario cierra el banner
 */
const AmbassadorReferralBanner = ({ 
    ambassadorName, 
    ambassadorLastName,
    ambassadorAlias, 
    onDismiss 
}) => {
    const displayName = ambassadorName + (ambassadorLastName ? " " + ambassadorLastName : "") || ambassadorAlias || 'un embajador';

    return (
        <Alert className="mb-4 bg-gradient-to-r from-aw-bluegray/90 to-aw-green/20 border-aw-green/70">
            <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faUserCheck} className="w-5 h-5 text-aw-green mt-0.5" />
                <AlertDescription className="flex-1">
                    <p className="font-medium text-aw-green">
                        ¡Llegaste a través de un link especial!
                    </p>
                    <p className="text-sm text-white mt-1">
                        <span className="font-semibold text-aw-green underline tracking-wider">{displayName}</span> te ha recomendado este evento. 
                        Al comprar tus tickets, estarás apoyando a tu embajador favorito.
                    </p>
                </AlertDescription>
                {onDismiss && (
                    <button
                        onClick={onDismiss}
                        className="text-gray-300 hover:text-gray-200 transition-colors"
                        aria-label="Cerrar"
                    >
                        <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
                    </button>
                )}
            </div>
        </Alert>
    );
};

export default AmbassadorReferralBanner;
